<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import aplicarMascaraData from '../mascara-data';

  export default {
    components: { DatePicker },
    data() {
      return {
        carregando: true,
        salvando: false,
        dataCorte: null,
      }
    },
    computed: {
      efeitoDataCorte() {
        if (!this.dataCorte) return 'Sem data de corte: todo o histórico entra no módulo e nada é descartado.';
        const data = moment(this.dataCorte);
        if (!data.isValid() || data.year() < 1990 || data.year() > 2100) return 'Informe uma data válida (dd/mm/aaaa) para ver o impacto no módulo.';
        const texto = data.format('DD/MM/YYYY');
        return 'Entram os lançamentos de ' + texto + ' em diante (incluindo o próprio dia). '
             + 'Anteriores a ' + texto + ' não aparecem na grade, na lista nem nos totais.';
      },
    },
    mounted() {
      this.carregar();
      this.$nextTick(() => aplicarMascaraData('dataCorteProjeto'));
    },
    methods: {
      carregar() {
        this.carregando = true;
        conciliacaoProjetoServico.configuracaoProjeto()
          .then(dados => {
            this.dataCorte = dados && dados.dataCorteProjeto ? moment(dados.dataCorteProjeto, 'YYYY-MM-DD').toDate() : null;
            this.carregando = false;
          })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar as configurações.'); });
      },
      semCorte() { this.dataCorte = null; },
      fechar() { this.$emit('fechar'); },
      dataValida() {
        if (!this.dataCorte) return true;

        const data = moment(this.dataCorte);
        return data.isValid() && data.year() >= 1990 && data.year() <= 2100;
      },
      salvar() {
        if (!this.dataValida()) {
          toastr.warning('Informe uma data de corte válida, no formato dd/mm/aaaa.');
          return;
        }

        this.salvando = true;
        conciliacaoProjetoServico.salvarConfiguracaoProjeto({
          dataCorteProjeto: this.dataCorte ? moment(this.dataCorte).format('YYYY-MM-DD') : ''
        })
          .then(() => { this.salvando = false; toastr.success('Configurações salvas.'); this.$emit('salvo'); })
          .catch(res => {
            this.salvando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível salvar as configurações.');
          });
      },
    },
  }
</script>

<template>
  <div class="conc-ov">
    <div class="conc-modal cfg-modal">

      <div class="cfg-head">
        <h4>Configurações da conciliação de projeto</h4>
        <small class="cfg-sub">Define o que o módulo exibe na lista e na grade de conciliação dos projetos.</small>
      </div>

      <div class="cfg-abas">
        <button type="button" class="ativa">Data de corte</button>
      </div>

      <div class="cfg-corpo">
        <div v-if="carregando" class="cfg-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

        <div v-else class="cfg-bloco">
          <div class="cfg-bloco-l">
            <div class="cfg-bloco-tit">Considerar lançamentos a partir de</div>
            <div class="cfg-bloco-aj">
              Vale para a grade do projeto, os lançamentos da conta bancária, os totais e a lista de conciliação.
              Entram os lançamentos a partir da data, inclusive nela; o que for anterior fica fora do módulo.
            </div>
          </div>
          <div class="cfg-bloco-r">
            <div class="cfg-corte-linha">
              <date-picker id="dataCorteProjeto" v-model="dataCorte" format="DD/MM/YYYY" lang="pt-br"
                           input-class="form-control" placeholder="dd/mm/aaaa" :editable="true" :shortcuts="false"
                           :clearable="true" :append-to-body="true" :popup-style="{ zIndex: 2100 }"></date-picker>
              <span class="cfg-divisor"></span>
              <button type="button" class="cfg-chip" :class="{ ativo: !dataCorte }" @click="semCorte">Sem corte</button>
            </div>
            <div class="cfg-efeito">{{ efeitoDataCorte }}</div>
          </div>
        </div>
      </div>

      <div class="cfg-foot">
        <button type="button" class="btn btn-primary" :disabled="salvando || carregando" @click="salvar">
          <i class="fa" :class="salvando ? 'fa-spinner fa-pulse' : 'fa-check'"></i> Salvar configurações
        </button>
        <button type="button" class="btn cfg-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .conc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.52); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 22px; }
  .conc-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28), 0 2px 6px rgba(16,24,40,.16); }
  .cfg-modal { width: 748px; max-width: 100%; max-height: 92vh; display: flex; flex-direction: column; overflow: hidden; }

  .cfg-head { padding: 16px 20px; border-bottom: 1px solid #e6e9ed; }
  .cfg-head h4 { margin: 0; font-size: 15.5px; font-weight: 600; color: #1c2024; }
  .cfg-sub { display: block; font-size: 12.5px; color: #6b747e; margin-top: 3px; }

  .cfg-abas { display: flex; padding: 0 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .cfg-abas button { height: 38px; padding: 0 12px; background: none; border: none; font-size: 12.5px; font-weight: 600; color: #6b747e; box-shadow: inset 0 -2px 0 transparent; }
  .cfg-abas button.ativa { color: #0a6d4d; box-shadow: inset 0 -2px 0 #0f8a5f; }

  .cfg-corpo { padding: 18px 20px 6px; min-height: 220px; }
  .cfg-carregando { text-align: center; color: #8a939c; padding: 40px 0; }

  .cfg-bloco { display: grid; grid-template-columns: 250px 1fr; gap: 22px; align-items: start; }
  .cfg-bloco-tit { font-size: 13px; font-weight: 600; color: #1c2024; }
  .cfg-bloco-aj { font-size: 12px; color: #6b747e; line-height: 1.5; margin-top: 4px; }
  .cfg-bloco-r { min-width: 0; }

  .cfg-corte-linha { display: flex; align-items: center; gap: 10px; min-height: 34px; }
  .cfg-corte-linha > * { flex: 0 0 auto; }
  .cfg-divisor { width: 1px; height: 22px; background: #e2e6ea; }
  .cfg-chip { height: 30px; padding: 0 11px; border-radius: 99px; border: 1px solid #c6ccd4; background: #fff; color: #5b6570; font-size: 12px; font-weight: 500; }
  .cfg-chip.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }
  .cfg-efeito { display: block; font-size: 12px; color: #5b6570; margin-top: 12px; line-height: 1.5;
                background: #f7f9fa; border: 1px solid #eef1f4; border-radius: 6px; padding: 9px 11px; }

  .cfg-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 13px 20px; background: #fafbfc; border-top: 1px solid #e6e9ed; }
  .cfg-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .cfg-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
</style>

<style>
  .cfg-modal .mx-datepicker-popup { z-index: 2100; }
  .cfg-modal .mx-datepicker { position: relative; display: inline-block; vertical-align: middle; width: 150px !important; }
  .cfg-modal .mx-datepicker .mx-input-wrapper, .cfg-modal .mx-datepicker input { width: 150px; }
  .cfg-modal .mx-input { height: 34px; border: 1px solid #c6ccd4; border-radius: 5px; box-shadow: none;
                         font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 13px; font-weight: 500; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ConfiguracaoProjetoModal.vue